import "./MiniTemplateCard.less";

import { Button, Card } from "antd";
import * as React from "react";

import { IBaseProps } from "lib/data/interfaces";

import { Cover } from "./Cover";

interface IMiniTemplateCardProps extends IBaseProps {
	repeatable?: boolean;
	required?: boolean;
	showCheckboxes?: boolean;
	title: string;
	templateType?: string;
	iconType?: string;
	onClick?: () => void;
	highlightOnClick?: boolean;
	highlighted?: boolean;
	className?: string | "mini-card";
	selected?: boolean;
}
interface IMiniTemplateCardState {
	repeatable: boolean;
	required: boolean;
	highlighted?: boolean;
}

export class MiniTemplateCard extends React.Component<IMiniTemplateCardProps, IMiniTemplateCardState> {

	public static readonly BasePath: string = "/admin/templateeditor";

	public constructor(props: IMiniTemplateCardProps) {

		super(props);

		this.state = {
			repeatable: props.repeatable || false,
			required: props.required || false,
			highlighted: props.highlighted || false,
		};
	}

	public onChangeRepeatable = () => {

		this.setState({ repeatable: !this.state.repeatable });
	}

	public onChangeRequired = () => {

		this.setState({ required: !this.state.required });
	}

	public onCardClick = () => {

		if (this.props.onClick) {

			this.props.onClick();
		}

		if (this.props.highlightOnClick != null) {

			let { highlighted } = this.state;
			highlighted = !highlighted;
			this.setState({ highlighted });
		}
	}


	public render() {
		return (

			<Button className="mini-template-card" onClick={this.onCardClick} type="ghost">
				<Card
					// className={`mini-template-card ${this.props.className} ${this.state.highlighted ? `highlighted` : ""} ${this.props.selected ? "selected" : null}`}
					cover={(
						<Cover
							iconType={this.props.iconType}
							repeatable={this.state.repeatable}
							onChangeRequired={this.onChangeRequired}
							onChangeRepeatable={this.onChangeRepeatable}
							showCheckboxes={(this.props.showCheckboxes !== undefined ? this.props.showCheckboxes : false)}
						/>
					)}
					bordered={false}
				>
					<div className="ant-card-meta mini-template-card-title-section overflow-meta-title">
						<div className="ant-card-meta-detail">
							<div className="ant-card-meta-title" >
								<p>
									{this.props.title}
								</p>
							</div>
							<div className="ant-card-meta-description">{this.props.templateType ? this.props.templateType : ""}</div>
						</div>
					</div>
				</Card>
			</Button>
		);
	}
}
